import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import S from 'string';
import accounting from 'accounting';
import APIClient from '../../client';
import HeaderView from '../../widgets/header';
import UserMenuView from '../../widgets/usermenu';
import FooterView from '../../widgets/footer';
import './style.css';

class View extends Component {
  constructor(params) {
    super(params);
    this.state = {

      items:            [],
      locality:         params.locality,
      user:             params.user,
      section:          'loading'

    };
    this.handleUserChange = params.handleUserChange;
  }
  componentDidMount = async () => {

    // set the animals
    document.title = 'Groups';

    // get the token
    let token = APIClient.getToken();

    // set the call
    let result = null;

    // handle errors
    try {
      result = await APIClient.call({

        path:   '/apps',
        query:  {
          token
        }
  
      });
    } catch(err) {
      this.setState({
        section: 'error'
      });
      return;
    }

    if(result.ok !== true) {
      this.setState({
        section: 'notfound'
      });
      return;
    }

    this.setState({

      section:      'loaded',
      items:        result.data

    });

  }
  render() {
    let content = null;
    if(this.state.section === 'loading') {
      return (
        <div className="wrapper initialoading-wrapper-bg">
          <HeaderView {...this.props} locality={this.state.locality}  user={this.state.user} state={this.state} />
          <div className="initialoading-inside-wrapper">
            <div className="initialoading">
              <div className="dots">
                <div className="dot dot1"></div>
                <div className="dot dot2"></div>
                <div className="dot dot3"></div>
                <div className="dot dot4"></div>
                <div className="dot5"></div>
              </div>
              <h2 className="initialoading-heading">One sec just loading...</h2>
            </div>
          </div>
          <FooterView locality={this.state.locality} state={this.state} />
        </div>);
    } else {
      let items = this.state.items || [];
      content = (<div>
        <UserMenuView user={this.state.user} section="apps"></UserMenuView>
        <div className="wrapper">
          <div className="apps">
            <div className="container">
              <div className="apps-inner">

                <div className="apps-controlbar">

                  <div className="apps-controlbar-meta">
                    <h2 className="apps-controlbar-heading">Apps</h2>
                    <p className="apps-controlbar-slogan">View your managed apps</p>
                  </div>
                  <div className="apps-controlbar-actions">
                    <Link className="apps-controlbar-cta" to={"/build"}>New</Link>
                  </div>
                  <div className="clearfix"></div>

                </div>

                <div className="apps-listing-items">
                  {
                    items.map((item) => {
                      return <div className="apps-listing-item">
                        <Link title={item.name} className="apps-listing-item-inner" to={"/apps/" + item.uid}>
                          <div className="apps-listing-item-preview">
                            <img alt="Group Logo" className="apps-listing-item-image" src={item.logo || 'https://cdn.chipndoodle.com/defaults/record.png'} />
                          </div>
                          <div className="apps-listing-item-meta">
                            <h3>{S(item.name || '').truncate(20, '...').s}</h3>
                            <p>{S(item.description || '').truncate(30, '...').s}</p>
                          </div>
                          <div className="clearfix"></div>
                        </Link>
                      </div>;
                    })
                  }
                </div>
                <div className="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>);
    }
    return (
      <div>
        <HeaderView {...this.props} locality={this.state.locality} section="me"  user={this.state.user} state={this.state} />
        {content}
        <FooterView locality={this.state.locality} state={this.state} />
      </div>
    );
  }
}

export default View;